export default "__VITE_ASSET__6ce2d20d__"